<template>
  <v-container fluid class="mx-1" v-if="languageData.labels">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
      <v-row>
        <v-col cols="12">
          <v-stepper v-model="e1" class="transparent elevation-0">
            <v-card class="mb-5">
              <v-stepper-header class="autoheight">
                <div class="py-5 pl-5 mr-3">
                  <BackButton />
                </div>
                <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
                <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ languageData.firstSectionTitle }}</v-stepper-step>
                <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

                <v-stepper-step :complete="e1 > 2" @click="setStep(2)" step="2">{{ languageData.secondSectionTitle }}</v-stepper-step>
              </v-stepper-header>
            </v-card>
            <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-form ref="formM" v-model="validM" @hook:mounted="handleForm('formM')">
                          <p class="text-h5">{{ languageData.firstSectionTitle }}</p>
                          <v-row>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 7 : 12" class="text-center">
                              <div class="avatar-upload">
                                <div class="avatar-edit">
                                  <input type='file' @change="storeLogo($event)" id="imageUpload" accept=".png, .jpg, .jpeg" />
                                  <label for="imageUpload"></label>
                                </div>
                                <div class="avatar-preview">
                                  <div id="imagePreview" :style="{ 'background-image': 'url(' + data.logo + ')' }">
                                  </div>
                                </div>
                              </div>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12">
                              <v-text-field
                                  :label="languageData.labels.company_name"
                                  v-model="data.companyName"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  :rules="rules.company_name"></v-text-field>
                              <v-text-field
                                  :label="languageData.labels.firstname"
                                  v-model="data.firstName"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  :rules="rules.firstname"></v-text-field>
                              <v-text-field
                                  :label="languageData.labels.lastname"
                                  v-model="data.lastName"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  :rules="rules.lastname"></v-text-field>
                              <template v-if="savingLogo">
                                <v-progress-circular
                                    :size="50"
                                    color="primary"
                                    indeterminate
                                ></v-progress-circular>
                              </template>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                     <div class="d-flex justify-end">
                        <v-btn
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(2)">
                      {{ languageData.next }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-form ref="formN" v-model="validN" @hook:mounted="handleForm('formN')">
                          <p class="text-h5 mb-7">{{ languageData.secondSectionTitle }}</p>
                          <v-row>
                            <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                              <v-text-field
                                  :label="languageData.labels.street"
                                  v-model="data.address.street"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  :rules="rules['address.street']"></v-text-field>
                            </v-col>
                            <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                              <v-text-field
                                  :label="languageData.labels.building_number"
                                  v-model="data.address.building_number"
                                  outlined
                                  height="55px"
                                  class="mb-4"
                                  :rules="rules['address.building_number']"></v-text-field>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                              <v-text-field
                                  :label="languageData.labels.flat_number"
                                  class="mb-4"
                                  outlined
                                  height="55px"
                                  v-model="data.address.flat_number"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                              <v-col
                                :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                                <v-text-field
                                    :label="languageData.labels.postal_code"
                                    v-model="data.address.postal_code"
                                    class="mb-4"
                                    outlined
                                    height="55px"
                                    :rules="rules['address.postal_code']"></v-text-field>
                              </v-col>
                              <v-col
                                :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                                <v-text-field
                                    :label="languageData.labels.city"
                                    v-model="data.address.city"
                                    class="mb-4"
                                    outlined
                                    height="55px"
                                    :rules="rules['address.city']"></v-text-field>
                              </v-col>
                              <v-col
                                v-if="countries.length > 0 && languageData.validateCompanyForm"
                                :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                                  <v-select
                                    v-model="data.address.country_id"
                                    :items="countries"
                                    :label="languageData.labels.country"
                                    outlined
                                    :rules="[v => !!v || languageData.validateCompanyForm.countryRequired]"
                                    item-value="id"
                                    item-text="name"
                                    height="55px"
                                  >
                                    <template slot='selection' slot-scope='{ item }'>
                                      {{ item.name }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                      {{ item.name }}
                                    </template>
                                  </v-select>
                              </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                    <div class="d-flex justify-end">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(1)">
                    {{ languageData.back }}
                  </v-btn>
                </div>
                  </v-card>
                </v-stepper-content>
                <div class="d-flex justify-end mb-5" style="padding: 0 24px" v-if="isSaveBtnVisible || isRequiredFieldsCompleted">
                  <v-btn
                      class="button-shadow"
                      color="primary"
                      style="padding-left: 25px !important; padding-right: 25px !important"
                      height="55px"
                      :loading="dataSaveIsFetching || updateIsFetching"
                      @click="saveMyCompanyData">{{ languageData.btnSaveText }}</v-btn>
                </div>
              </v-stepper-items>
            </v-card>
          </v-stepper>
        </v-col>
      </v-row>
    <ModalInfo :typeInfo="modalData.typeInfoCompanySave || modalDataUpdate.typeInfoCompanyUpdate" :headModal="modalData.headInfoCompanySave || modalDataUpdate.headInfoCompanyUpdate" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isCompanySave || isCompanyUpdate" :text-modal="modalData.textInfoCompanySave || modalDataUpdate.textInfoCompanyUpdate"></ModalInfo>
    <ModalInfo :typeInfo="modalDataExemptionSet.typeInfoExemptionSet" :headModal="modalDataExemptionSet.headInfoExemptionSet" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModalExemptionFailure" :show-modal="isExemptionSet" :text-modal="modalDataExemptionSet.textInfoExemptionSet"></ModalInfo>
    <ModalInfo :typeInfo="modalDataLogoSave.typeInfoLogoSave" :headModal="modalDataLogoSave.headInfoLogoSave" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModalLogo" :show-modal="isLogoSave" :text-modal="modalDataLogoSave.textInfoLogoSave"></ModalInfo>
    <ModalInfo
        @doOperation="cancelSubscription"
        :isLoadingBtn="false"
        :typeInfo="'red'"
        :headModal="languageData.cancelSubscriptionHeadInfo"
        :btnAgreeText="languageData.btnYesText"
        :btnDisAgreeText="languageData.btnDisAgreeText"
        :visDisAgreeBtn="true" @clicked="hideCancelSubscriptionModal"
        :show-modal="isShowModalCancelSubscription"
        :text-modal="languageData.cancelSubscriptionTextInfo"></ModalInfo>
    <ModalInfo :layout="'modalForm'" @clicked="hideModalExemption" :hidden-agree-btn="true" :show-modal="isShowExemptionFormModal">
      <template v-slot:body>
        <CompanyExemptionForm></CompanyExemptionForm>
      </template>
    </ModalInfo>
    <ModalInfo
        @doOperation="deleteExemptionRequest"
        :headModal="languageData.modalDeleteExemption.head"
        :isLoadingBtn="false"
        :typeInfo="'info'"
        :text-modal="languageData.modalDeleteExemption.textInfo"
        :btnDisAgreeText="languageData.btnDisAgreeText"
        :btnAgreeText="languageData.btnAgreeText"
        :visDisAgreeBtn="true" @clicked="hideModalExemptionDelete"
        :show-modal="isShowExemptionDeleteModal"
        ></ModalInfo>
  </v-container>
</template>
<script>
  import vatTypes from "../../enums/VatTypeEnum";
  import { mapActions, mapState } from "vuex";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import handleFormError from "../../../../helpers/handleFormError";
  import hexColorGenerator from "../../../../helpers/hexColorGenerator";
  import FavoriteContacts from "../FavoriteContacts/FavoriteContacts.vue";
  import moment from "moment";
  import CompanyExemptionForm from "../CompanyExemptionForm/CompanyExemptionForm";
  import BackButton from "../../../../components/Global/BackButton";

  export default {
    name: "MyCompanyForm",
    props: {
      layout: String
    },
    watch: {
      validM: function() {
        this.isValidM();
      },
      validN: function(newValue) {
        if (newValue) {
          this.isValidN();
        }  
      },
      validO: function() {
        this.isValidO()
      },
    },
    components: {
      BackButton,
      CompanyExemptionForm,
      ModalInfo,
      FavoriteContacts
    },
    data() {
      return {
        validM: false,
        validN: false,
        validO: false,
        e1: 1,
        rules: {},
        items: vatTypes,
        data: {
          address: {},
          isVatPayer: true,
        },
        logo: "",
        logoCompanyBase64: "",
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          corner: 'right',
          timeout: 7500,
          title: null,
          visible: false
        },
        showExemptionAddButton: false,
        validExemption: false,
        isSaveBtnVisible: false
      }
    },
    computed: {
      checkExemptions: {
        get() {
          if(Object.prototype.hasOwnProperty.call(this.data, 'exemptions')) {
            return this.data.exemptions !== null ? this.data.exemptions.length > 0 : false;
          }
          return true;
        },
        set(value) {
          this.data.exemptions = value;
        }

      },
      ...mapState("saveLogo", {
        savingLogo: state => state.savingLogo,
        modalDataLogoSave: state => state.modalDataLogoSave,
        isLogoSave: state => state.isLogoSave
      }),
      ...mapState("myCompanyDataSave", {
        dataSaveIsFetching: state => state.dataSaveIsFetching,
        modalData: state => state.modalData,
        isCompanySave: state => state.isCompanySave,
      }),
      ...mapState("getCompanyUser", {
        dataReceive: state => state.dataReceive,
      }),
      ...mapState("getCompany", {
        dataCompany: state => state.dataCompany
      }),
      ...mapState("updateCompany", {
        updateIsFetching: state => state.updateIsFetching,
        modalDataUpdate: state => state.modalDataUpdate,
        isCompanyUpdate: state => state.isCompanyUpdate
      }),
      ...mapState('getSubscription', {
        dataSubscription: state => state.dataSubscription,
      }),
      ...mapState('cancelSubscription', {
        isShowModalCancelSubscription: state => state.isShowModalCancelSubscription,
        isSubscriptionCanceling: state => state.isSubscriptionCanceling
      }),
      ...mapState('subscribe', {
        isFetching: state => state.isFetching
      }),
      ...mapState("setCompanyExemption", {
        isShowExemptionFormModal: state => state.isShowExemptionFormModal,
        isShowExemptionDeleteModal: state => state.isShowExemptionDeleteModal,
        isExemptionSet: state => state.isExemptionSet,
        modalDataExemptionSet: state => state.modalDataExemptionSet,
        exemptionsList: state => state.exemptionsList,
      }),
       ...mapState("preventDataLost", {
        isDataChanged: state => state.isDataChanged,
      }),
      ...mapState("getCountries", {
        countries: state => state.countries,
      }),

      checkIfExemptions() {
        if (this.data.exemptions !== null && Object.prototype.hasOwnProperty.call(this.data, 'exemptions')) {
          return this.data.exemptions === true || this.data.exemptions.length > 0
        } else {
          return false;
        }
      },
      getPriceOfSubscriptionPlan() {
        if (this.dataSubscription.subscriptionPlan) {
          if (Number.isInteger(this.dataSubscription.subscriptionPlan.price)) {
            return ((this.dataSubscription.subscriptionPlan.price / 100) / this.dataSubscription.subscriptionPlan.interval).toFixed(2) + '€';
          } else {
            return (this.dataSubscription.subscriptionPlan.price / this.dataSubscription.subscriptionPlan.interval).toFixed(2) + '€';
          }
        } else {
          return 0 + '€'
        } 
      },
      isRequiredFieldsCompleted() {
        if ((this.data.companyName && 
            this.data.firstName && 
            this.data.lastName && 
            this.data.address.street &&
            this.data.address.building_number &&
            this.data.address.postal_code &&
            this.data.address.city && 
            this.data.address.country_id)) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapActions("myCompanyDataSave", ["storeData", "updateVisibleModal"]),
      ...mapActions("getCompanyUser", ["getCompanyUser"]),
      ...mapActions("getCompany", ["getCompany"]),
      ...mapActions("updateCompany", ["updateCompany", "updateVisibleModalUpdate"]),
      ...mapActions("saveLogo", ["saveLogo", "updateVisibleModalLogoSave"]),
      ...mapActions("getSubscription", ["getSubscriptionData"]),
      ...mapActions("cancelSubscription", ["updateVisibleModalCancelSubscription", "cancelSubscriptionRequest"]),
      ...mapActions('subscribe', ['sendSubscribeLinkRequest']),
      ...mapActions("setCompanyExemption", ["updateVisibleExemptionFormModal", "deleteExemption", "updateVisibleExemptionDeleteModal", "updateVisibleModalExemptionFailure", "getExemptions"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
      ...mapActions("getCountries", ["getCountriesRequest"]),

      handleEventListenerOnInputs() {
        if (!this.isDataChanged && !this.isCompanySave && !this.isCompanyUpdate) {
          this.updateDataInFormIsChanged(true);
        }
      },
      handleForm(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.addEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },
      removeEventListeners(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.removeEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },

      hideModalLogo: function() {
        this.updateVisibleModalLogoSave(false);
      },
      storeLogo: function(event) {
        const logo = event.target.files[0];
        const layout = this.layout;
        this.saveLogo({ creds: { logo, layout } });
      },
      hideModal: function() {
        if(this.layout === "edit") {
          this.updateVisibleModalUpdate(false);
        } else {
          this.updateVisibleModal(false);
        }
      },
      hideModalExemptionFailure() {
          this.updateVisibleModalExemptionFailure(false);
      },
      saveMyCompanyData: function() {
        this.$refs.formM.resetValidation();
        this.$refs.formN.resetValidation();
        this.data.hexColor = hexColorGenerator();
        this.rules = [];
        this.data.language = localStorage.getItem("language");
        if(this.data.isVatPayer === null) {
          this.data.isVatPayer = false;
        }
        this.updateDataInFormIsChanged(false);
        if(this.layout === "edit") {
          this.updateCompany({creds: this.data});
        } else {
          this.storeData({creds: this.data});
        }
      },
      setStep: function(step) {
        this.e1 = step;
        if (step === 2) {
          this.isSaveBtnVisible = true;
        }
      },
      isValidM: function() {
        if(this.validM === false) {
          this.setStep(1);
        }
      },
      isValidN: function() {
        if(this.validM !== false && this.validN === false) {
          this.setStep(2);
        }
      },
      isValidO: function() {
        if(this.validM !== false && this.validN !== false && this.validO === false) {
          this.setStep(3);
        }
      },
      getSubscriptionDays() {
        let subDate = moment(this.dataSubscription.valid_until, "YYYY-MM-DD").add(1, 'days');
        let todayDate = moment();
        return moment.duration(subDate.diff(todayDate)).asDays().toFixed(0)
      },
      isSubscriptionPast() {
        return parseInt(this.getSubscriptionDays()) <= 0;
      },
      rescaleSubscriptionDays() {
        let x = 30;
        let days = parseInt(this.getSubscriptionDays());
        return (days * 100) / x;
      },
      showCancelSubscriptionModal() {
        this.updateVisibleModalCancelSubscription(true);
      },
      hideCancelSubscriptionModal() {
        this.updateVisibleModalCancelSubscription(false);
      },
      cancelSubscription() {
        this.cancelSubscriptionRequest();
      },
      sendSubscriptionRequest() {
        this.sendSubscribeLinkRequest();
      },
      getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      showExemptionForm() {
        this.updateVisibleExemptionFormModal(true);
      },
      hideModalExemption() {
        this.updateVisibleExemptionFormModal(false);
      },
      hideModalExemptionDelete() {
        this.updateVisibleExemptionDeleteModal(false);
      },
      deleteExemptionRequest() {
        this.deleteExemption();
      },
    },
    mounted() {
      if(this.layout === "edit") {
        this.getCompany();
        this.getExemptions();
      } else {
        this.getCompanyUser();
        this.getExemptions();
      }
      this.getCountriesRequest();
      eventBus.$on("setCompanyFormData", () => {
        if(this.layout === "edit") {
          this.data = this.dataCompany;
        } else {
          this.data = this.dataReceive;
        }
      });
      eventBus.$on("storeDataSuccess", () => {
        this.updateDataInFormIsChanged(false);
        this.e1 = 1;
      });
      eventBus.$on("storeDataFailure", (errorsData) =>{
        this.rules = handleFormError(errorsData);

        this.validM = this.$refs.formM.validate();
        this.validN = this.$refs.formN.validate();
        this.isValidM();
        this.isValidN();
        this.isValidO();
      });
      if(this.layout === "edit") {
        this.data.logo = localStorage.getItem("companyLogo");
        eventBus.$on("updateLogoCompany", (logo) => {
          this.data.logo = logo;
        });
      } else {
        eventBus.$on("updateMyCompany", () => {
          this.data.logo = localStorage.getItem("companyLogo");
        });
      }
      eventBus.$on("cancelSubscriptionSuccess", (dataReceive) => {
        this.updateVisibleModalCancelSubscription(false);
        this.getSubscriptionData();
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message)
      });
      eventBus.$on("setExemptionSuccess", (dataReceive) => {
        this.updateVisibleExemptionFormModal(false);
        this.getExemptions();
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message)
      });
      eventBus.$on("deleteExemptionSuccess", (dataReceive) => {
        this.updateVisibleExemptionFormModal(false);
        this.getExemptions();
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message)
      });
      eventBus.$on("setExemptionFailure", (errorsData) =>{
        this.rules = handleFormError(errorsData);
        this.validExemption = this.$refs.formM.validate();
      });

      eventBus.$on("deleteFavoriteContactSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message)
      });
      eventBus.$on("changeLanguage", () => {
        this.getCountriesRequest();
      });
    },
    beforeDestroy() {
      this.removeEventListeners('formM');
      this.removeEventListeners('formN');
    },
  }
</script>

<style src="./MyCompanyForm.scss" lang="scss"></style>